import  React, {use, useEffect, useState} from 'react';
import alertImg from './../assets/img/AlertImg.png';
import './styles/MensajeError.css';
import { hover } from '@testing-library/user-event/dist/hover';


//RepPrA
const MensajeAlerta = ({ mensaje, show, onClose }) => {


    const handleCerrarMsgAlerta = () => {
        if (onClose) { 
            onClose(); 
        }
    };

    if (!show) {
        return null;
    }

    return (
        <div className='mEMain'>
            <img src={alertImg} alt="Error" /> 
            <p>{mensaje}</p>
            <button className='buttonStandart' onClick={handleCerrarMsgAlerta}>Aceptar</button>
        </div>
    );
};


export default MensajeAlerta;